/**
 * DOC HELPER — context_activity.v1 frontend projection.
 *
 * This module only displays backend-owned activity metadata. It must not
 * synthesize workflow state or mutate authoritative context.
 */


function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

function coercePercent(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.max(0, Math.min(100, Math.round(parsed * 100)));
}

export function resolveLatestContextActivity(items) {
  const timelineItems = Array.isArray(items) ? items : [];
  return timelineItems.reduceRight((selected, item) => {
    if (selected) return selected;
    if (String(item?.type || '').trim() !== 'message' || String(item?.role || '').trim() !== 'assistant') {
      return null;
    }
    return resolveObject(item.contextActivity);
  }, null);
}

export function buildActivityLines(activity, formatters) {
  return formatters.buildContextActivityLines(activity);
}

export function resolveActivityWindowPercent(activity) {
  return coercePercent(resolveObject(activity)?.progress);
}
